<template>
  <div id="app" class="wrapper">
    <common-view>
      <fade-in>
        <router-view></router-view>
      </fade-in>
    </common-view>
  </div>
</template>

<script>
import CommonView from '@/components/CommonView.vue';
import FadeIn from '@/components/FadeIn.vue';

export default {
  name: 'App',
  components: {
    CommonView,FadeIn
  }
}
</script>

<style lang="scss">

</style>
